import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field } from 'redux-form/immutable';
import { injectIntl, intlShape } from 'react-intl';
import { InputGroup } from 'cstar-react-primitives/lib/redux-form/InputGroup';
import Markdown from 'markdown-to-jsx';
import classNames from 'classnames/dedupe';

import { getBrandCode } from '../brand/brandSelectors';

import LoyaltyImage from './LoyaltyImage';
import { getLoyaltyHelpText, getLoyaltyImageSrc } from './loyaltySelectors';
import { LOYALTY_NUMBER_MAX_LENGTH, LOYALTY_FIELD } from './loyaltyModule';
import loyaltyMessages from './loyaltyMessages';


export const LoyaltyField = ({
    loyaltyHelpText,
    cashbotName,
    standaloneField,
    intl,
    doFocus,
    brandCode,
    loyaltyImageUrl
}) => {
    const loyaltyFieldProps = {
        atts: { type: 'text', maxLength: LOYALTY_NUMBER_MAX_LENGTH },
        hasMaxLengthCounter: false,
        label: intl.formatMessage(loyaltyMessages.loyaltyLabel),
        component: InputGroup,
        helper: '',
        name: LOYALTY_FIELD,
        isRequiredField: false,
        cashbotName,
        doFocus
    };

    const loyaltyImageProps = {
        logoAlt: intl.formatMessage(loyaltyMessages.logoAlt),
        brandCode,
        loyaltyImageUrl
    };

    return (
        <div className={classNames('loyalty-field', { 'loyalty-field--standalone': standaloneField })}>
            {loyaltyImageUrl && <LoyaltyImage {...loyaltyImageProps} />}
            <Field {...loyaltyFieldProps} />
            {loyaltyHelpText && <Markdown className="loyalty-field--help-text">{loyaltyHelpText}</Markdown>}
        </div>
    );
};

LoyaltyField.defaultProps = {
    loyaltyHelpText: null,
    standaloneField: false,
    doFocus: false,
    loyaltyImageUrl: null
};

LoyaltyField.propTypes = {
    cashbotName: PropTypes.string.isRequired,
    intl: intlShape.isRequired,
    loyaltyHelpText: PropTypes.string,
    standaloneField: PropTypes.bool,
    doFocus: PropTypes.bool,
    brandCode: PropTypes.string.isRequired,
    loyaltyImageUrl: PropTypes.string
};

const mapStateToProps = state => ({
    loyaltyHelpText: getLoyaltyHelpText(state),
    brandCode: getBrandCode(state),
    loyaltyImageUrl: getLoyaltyImageSrc(state)
});

export default connect(mapStateToProps)(injectIntl(LoyaltyField));
